const NAMES = {
  'rajeshmaydev@gmail.com': 'mama',
  'indira02032001@gmail.com': 'papa',
};

export const displayName = (email) => NAMES[email] ?? email?.split('@')[0] ?? '';
